import React from 'react';
import Header from '../../../../components/layout/headers/Header'
import Sidebar from '../../../../components/layout/navigation/sidebar/DynamicSidebar'; 
import AllUsersProfileReportTable from './ApproveLoansTable'

const AllUsersProfileReport = () => {

    
    return (
        <>
            <Header />
            <Sidebar />
            <div className="content-body">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    <AllUsersProfileReportTable  />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AllUsersProfileReport;